export const random_rgba = () => {
    var o = Math.round, r = Math.random, s = 255;
    let a = r().toFixed(1);
    let value = 'rgba(' + o(r() * s) + ',' + o(r() * s) + ',' + o(r() * s) + ',' + (a == '0.0' ? '0.1' : a) + ')'
    return value;
}